function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.7 12.062l-7.5 4.33v-8.66l7.5 4.33z",
  stroke: "#29354C",
  strokeWidth: 2
});

var SvgIconRunOutline = function SvgIconRunOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjcwMDIgMTIuMDYyMkw4LjIwMDIgMTYuMzkyM0w4LjIwMDIgNy43MzIwNUwxNS43MDAyIDEyLjA2MjJaIiBzdHJva2U9IiMyOTM1NEMiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { SvgIconRunOutline as ReactComponent };